import React, { useState } from 'react';
import Year2SetupView from './Year2SetupView';
import Year2PortfolioFlow from './Year2PortfolioFlow';

const TABS = [
  { id: 'setup', label: 'Squad Setup' },
  { id: 'portfolio', label: 'Portfolio' },
];

export default function Year2Portal({
  user,
  students,
  liveSchools = [],
  year2Discovery = null,
  year2DiscoveryLoading = false,
  year2DiscoveryError = '',
  onRefreshYear2Discovery,
  onError,
  onSuccess,
}) {
  const [activeTab, setActiveTab] = useState('setup');

  return (
    <div className="animate-fade-in">
      <div className="dashboard-title-row">
        <div>
          <h1 className="dashboard-title">Year 2 Glosco Policy Studio</h1>
          <p className="dashboard-subtitle">
            Process Year 2 cohorts school by school — set up squads, review portfolio readiness, and apply seals.
          </p>
        </div>
      </div>

      <div className="tab-nav-bar" style={{ marginBottom: '24px' }}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`tab-nav-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'setup' && (
        <Year2SetupView
          students={students}
          liveSchools={liveSchools}
          preloadedSchools={year2Discovery?.schools || null}
          preloadedCohortsBySchool={year2Discovery?.cohortsBySchool || null}
          bootstrapLoading={year2DiscoveryLoading}
          bootstrapError={year2DiscoveryError}
          onRefresh={onRefreshYear2Discovery}
          onError={onError}
          onSuccess={onSuccess}
        />
      )}

      {activeTab === 'portfolio' && (
        <Year2PortfolioFlow
          user={user}
          liveSchools={liveSchools}
          preloadedSchools={year2Discovery?.schools || null}
          preloadedCohortsBySchool={year2Discovery?.cohortsBySchool || null}
          bootstrapLoading={year2DiscoveryLoading}
          bootstrapError={year2DiscoveryError}
          onRefresh={onRefreshYear2Discovery}
          onError={onError}
          onSuccess={onSuccess}
        />
      )}
    </div>
  );
}
